import { render } from "./TopBarSecureMessagesNotificationCard.vue?vue&type=template&id=cc765804&scoped=true"
import script from "./TopBarSecureMessagesNotificationCard.vue?vue&type=script&lang=js"
export * from "./TopBarSecureMessagesNotificationCard.vue?vue&type=script&lang=js"

import "./TopBarSecureMessagesNotificationCard.vue?vue&type=style&index=0&id=cc765804&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc765804"]])

export default __exports__